<!--  -->
<template>
  <div v-loading="loadingtable">
    <div class="band_box">
      <div>
        <div class="serch_box">
          <!-- <el-input v-model="obr.app_id" placeholder="请输入自有员工编号" style="width:200px" />
          <el-input v-model="obr.name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
          <el-input
            v-model="obr.app_id"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入小程序编号"
          />
          <el-input
            v-model="obr.name"
            clearable
            style="width:240px;margin-right:10px"
            placeholder="请输入小程序名称"
          />
          <!-- <el-select v-model="obr.onlyMe" placeholder="请选择" style="margin-left:20px">
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select> -->
          <el-button
            type="primary"
            class="search_icon"
            icon="el-icon-search"
            @click="secahclkick"
          />
        </div>
        <div class="choses_box">
          <div
            class="select_box"
            :class="[fullName ? 'choose_blockr' : '']"
            @click="whole"
          />
          <div
            v-if="fullName"
            @click="whole"
          >
            取消全选
          </div>
          <div
            v-else
            @click="whole"
          >
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div
            v-for="item, index in arr"
            :key="index"
            :class="[item.tips ? 'have ' : '']"
            class="choose_block"
          >
            <!-- {{ item.canChecked }} -->
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="[item.tips ? 'choose_blockr' : '']"
              @click="itenclick(item, index)"
            />
            <span>{{ item.account_name }}</span>
          </div>
        </div>

      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的小程序</div>
        <el-tag
          v-for="itemr, index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          :closable="!itemr.sign"
          @close="rightclick(itemr.app_id, index)"
        >
          {{ itemr.account_name }}
        </el-tag>
      </div>
    </div>
    <div>
      <pagination-right
        style="padding:0px;margin-top:20px;justify-content:left"
        :total="total"
        :current-page="obr.page"
        :page-sizes="[50]"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <div class="que_box">
      <el-button
        type="primary"
        @click="quebtn"
      >确定</el-button>
    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { appletlistrw } from '@/api/sourceMaterial.js'
import { articleSettinggetAppletAndBind } from '@/api/workWechat.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        page: 1,
        page_size: 50,
        keyword: null,
        // mini_program_type: 4
      },
      accountarr: [
        {
          value: 1,
          label: '查看组内授权员工'
        },
        {
          value: 2,
          label: '我授权的企业员工'
        }
      ],
      total: null,
      sp_strategy_no: null,
      loadingtable: false,
      type: null
    }
  },
  computed: {
    // fullName: function () {
    //   // return this.arr
    //   //   .filter(num => {
    //   //     return num.can_checked !== 9
    //   //   })
    //   //   .every(function (item) {
    //   //     return item.tips === true
    //   //   })
    //   // return this.arr.filter((num) => {
    //   //   return num.canChecked !== 9
    //   // }).every(function(item) {
    //   //   return item.tips === true
    //   // })
    // }
    fullName: function() {
      return this.arr.filter((num) => {
        return num.can_checked !== 9
      }).every(function(item) {
        return item.tips === true
      })
    }
  },
  created() {},
  mounted() {},
  methods: {
    secahclkick() {
      this.obr.page = 1
      this.list()
    },

    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      // this.arrsw = []
      // this.arrsw = this.arrs.map(item => { // item是数组中的每一个值
      //   return item.app_id
      // })
      this.$emit('bandarr', this.arrs)
      // console.log('arrsw', this.arrsw)
    },

    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ app_id: item.app_id, account_name: item.account_name })
      } else {
        const index = this.arrs.findIndex(items => {
          return items.app_id === item.app_id
        })
        this.arrs.splice(index, 1)
      }
      this.$emit('gruonpidcallabck', this.arrs)
    },
    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex(items => {
              return items.app_id === item.app_id
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            console.log(11)
            item.tips = true
            this.arrs.map(re => re.app_id).includes(item.app_id) || this.arrs.push({ app_id: item.app_id, account_name: item.account_name })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
      this.$emit('gruonpidcallabck', this.arrs)
    },
    rightclick(app_id, index) {
      console.log(app_id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.app_id === app_id) {
          items.tips = false
        }
      })
      this.$emit('gruonpidcallabck', this.arrs)
    },
    sendr(arr, id) {
      // this.arrs = arr
      // this.list()
      console.log('id:', id)
      if (id === null) {
        this.arrs = arr
        this.list()
      } else {
        // if (arr !== undefined) {
        //   this.arrs = JSON.parse(JSON.stringify(arr))
        // }
        this.arrs = arr
        this.getlist(id)
      }
    },
    async list() {
      this.loadingtable = true
      const data = await appletlistrw(this.obr)
      this.total = data.data.total
      data.data.list.forEach(item => {
        item.tips = false
        item.can_checked = 1
      })
      this.arr = data.data.list
      this.arr.forEach(item => {
        // console.log('item', item)
        this.arrs.forEach(items => {
          if (items.app_id === item.app_id) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      this.loadingtable = false
      console.log('data', data)
    },
    async getlist(article_id) {
      this.loadingtable = true
      const data = await articleSettinggetAppletAndBind({
        page: 1,
        page_size: 200,
        article_id
      })
      // this.total = data.data.total
      data.data.forEach(item => {
        item.tips = false
      })
      this.arr = data.data
      this.arr.forEach(item => {
        // console.log('item', item)
        this.arrs.forEach(items => {
          if (items.app_id === item.app_id) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      this.loadingtable = false
      console.log('data', data)
    },

    // 分页
    fetchPageSize(e) {
      this.obr.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}

.que_box {
  margin-top: 20px;
}

.have {
  color: #409eff;
}

.serch_box {
  display: flex;
  margin-bottom: 10px;
}

.search_icon {
  margin-left: 10px;
}

.band_box {
  display: flex;
}

.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}

.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}

.choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}

.choose_blockr {
  background: #409eff;
}

.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 450px;
  overflow-y: scroll;
  width: 350px;
  /* overflow: hidden;
  overflow-y: scroll; */
}

/* :-webkit-scrollbar {
     height: 0 !important;
} */
/* ::-webkit-scrollbar {
     width: 0 !important;height: 0;
  } */
.choiceofficialaccount {
  margin-bottom: 10px;
}

.select_spacing {
  margin-bottom: 5px;
}

.choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  overflow-x: scroll;
  /* min-width: 600px; */
}
</style>
